import { render } from "./Charter.vue?vue&type=template&id=6dce1217&scoped=true"
import script from "./Charter.vue?vue&type=script&lang=js"
export * from "./Charter.vue?vue&type=script&lang=js"

import "./Charter.vue?vue&type=style&index=0&id=6dce1217&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dce1217"]])

export default __exports__